<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {
        main_tab: 4,
        sub_tab: '4.3',

        hide: false,

        nav_items : [
          {
            id: 4,
            title: 'REVINRE/Hunt',
            children: [
              {id: 1, title: 'Design Tests'},
              {id: 2, title: 'Verbiage Tests'},
              {id: 3, title: 'Offices Lists'},
              {id: 4, title: 'Offices Single'},
              {id: 5, title: 'Agents Lists'},
              {id: 6, title: 'Agents Single'},
            ],
          },
          {
            id: 3,
            title: 'Competition content',
            children: [
              {id: 1, title: 'Overview'},
              {id: 2, title: 'REVINRE'},
              {id: 3, title: 'Homie'},
              {id: 4, title: 'Flat Fee Group'},
              {id: 5, title: 'Houzeo'},
              {id: 6, title: 'Listed Simply'},
              {id: 7, title: 'AZ Flat Fee'},
            ],
          },
          {
            id: 2,
            title: 'Future planning',
            children: [
              {id: 1, title: 'Cards: Stories that sell'},
              {id: 2, title: 'Future site layout'},
            ],
          },
          {
            id: 1,
            title: 'How it works examples',
            children: [
              {id: 1, title: 'Example 1'},
            ],
          },
        ],
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <div class="row m-0">
    <div class="position-relative bg-dark text-white" :class="hide ? '_w-0' : '_w-200'">
      <div class="position-absolute bg-dark _c-pointer" style="right:-25px;top:100px;width:30px;height:40px;z-index:1;border-radius: 5px;" @click="hide ? hide = false : hide = true"><Icon icon="ri:arrow-left-s-line" height="20" style="margin-left:5px;margin-top:10px;" /></div>
      <div class="small pt-6">
        <div class="p-2 small">
          <div class="">Development examples.</div>
          <div class="text-success">Click parent items to reveal sub items.</div>
          <div class="text-success">Click sub items to load page content.</div>
          <div class="text-purple">Current page: {{sub_tab}}</div>
        </div>
        <ul class="list-unstyled m-0 small border-top border-black">
          <li v-for="(item, item_i) in nav_items" :key="item_i" class="border-bottom border-black">
            <div class="px-2 py-2 _c-pointer" @click="main_tab == item['id'] ? main_tab = 0 : main_tab = item['id']" :class="main_tab == item['id'] ? 'text-primary' : ''">
              <div class="float-right" style="transform: rotate(90deg);">{{main_tab == item['id'] ? '>' : '^'}}</div>
              {{item['id']}}: {{item.title}}
            </div>
            <ul v-if="main_tab == item['id']" class="list-unstyled bg-darken-gray-900 ">
              <li v-for="(sub_item, sub_item_i) in item.children" :key="sub_item_i" class="pl-2 border-top border-black _c-pointer" @click="sub_tab = item['id']+'.'+sub_item['id']" :class="sub_tab == item['id']+'.'+sub_item['id'] ? 'text-primary' : ''">
                <div class="p-2">{{item['id']+'.'+sub_item['id']}}: {{sub_item.title}}</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

    </div>
    <div class="col p-0">


      <w-1-1 v-if="sub_tab == '1.1'" :website="website"></w-1-1>


      <w-2-1 v-if="sub_tab == '2.1'" :website="website"></w-2-1>
      <w-2-2 v-if="sub_tab == '2.2'" :website="website"></w-2-2>


      <w-3-1 v-if="sub_tab == '3.1'" :website="website"></w-3-1>
      <w-3-2 v-if="sub_tab == '3.2'" :website="website"></w-3-2>
      <w-3-3 v-if="sub_tab == '3.3'" :website="website"></w-3-3>
      <w-3-4 v-if="sub_tab == '3.4'" :website="website"></w-3-4>
      <w-3-5 v-if="sub_tab == '3.5'" :website="website"></w-3-5>
      <w-3-6 v-if="sub_tab == '3.6'" :website="website"></w-3-6>
      <w-3-7 v-if="sub_tab == '3.7'" :website="website"></w-3-7>

      
      <w-4-1 v-if="sub_tab == '4.1'" :website="website"></w-4-1>
      <w-4-2 v-if="sub_tab == '4.2'" :website="website"></w-4-2>
      <w-4-3 v-if="sub_tab == '4.3'" :website="website"></w-4-3>
      <w-4-4 v-if="sub_tab == '4.4'" :website="website"></w-4-4>
      <w-4-5 v-if="sub_tab == '4.5'" :website="website"></w-4-5>
      <w-4-6 v-if="sub_tab == '4.6'" :website="website"></w-4-6>


    </div>

  </div>
</template>
